import { Button, Card, Form, Input, Select, Checkbox, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";
import { Imasterdataagenda } from "../common";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { ActivityService } from "../services/agendas-service";
import "../../../index.css";
import { loadAppConfig } from "../../../configs/app-config";
interface Props {
  masterDataAgenda: Imasterdataagenda[];
}

export const FormcreateActivity: React.FC<Props> = ({ masterDataAgenda }): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [form] = Form.useForm();
  const [fixlimit, setFixlimit] = useState<boolean>(false);

  const handleCreate = async () => {
    const data = {
      name: form.getFieldValue("name"),
      description: form.getFieldValue("description"),
      type: String(form.getFieldValue("type")),
      number: fixlimit === true ? Number(form.getFieldValue("number")) : 0,
      numberChar: fixlimit === true ? "P" : String(form.getFieldValue("type")) === "2" ? "C" : "D",
      fixLimit: fixlimit,
    };
    await ActivityService(apiBaseUrl)
      .createAgenda(data)
      .then((resultCreate) => {
        if (resultCreate) {
          message.success("สำเร็จ");
          form.resetFields();
        }
      });
  };
  return (
    <div>
      <Card title={`ข้อมูลการกรอกแบบฟอร์ม`}>
        <Form form={form} layout="vertical" onFinish={handleCreate}>
          <Form.Item
            name={`name`}
            label={`Name`}
            rules={[
              {
                required: true,
                message: "Please input name!",
              },
            ]}
          >
            <Input placeholder="text" />
          </Form.Item>
          <Form.Item
            name={`description`}
            label={`Description`}
            rules={[
              {
                required: true,
                message: "Please input description!",
              },
            ]}
          >
            <TextArea placeholder="text" maxLength={500} showCount />
          </Form.Item>
          <Form.Item name={`event`} label={`Type`}>
            <Select
              placeholder="please select"
              options={masterDataAgenda.map((item: Imasterdataagenda) => {
                return { value: item.id, label: item.text };
              })}
            />
          </Form.Item>
          <Form.Item name={`fixlimit`} label={`Fix Limit`}>
            <Checkbox
              onChange={(value: any) => {
                setFixlimit(value.target.checked);
              }}
            >{`จำกัดจำนวนผู้เข้าร่วม`}</Checkbox>
          </Form.Item>
          {fixlimit === true ? (
            <Form.Item name={`number`} label={`Number`}>
              <Input type="number" placeholder="text" />
            </Form.Item>
          ) : (
            <></>
          )}
          <Form.Item name={`type`} label={`Card Type`}>
            <Select
              placeholder="please select"
              options={[
                { label: "Card 1", value: "1" },
                { label: "Card 2", value: "2" },
                { label: "Card 3", value: "3" },
              ]}
            />
          </Form.Item>

          <Form.Item className="flex justify-center">
            <Button htmlType="submit" type="primary">{`สร้างกิจกรรม`}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
